import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Creators as Actions } from "store/ducks/quotesDashboard";
//components
import QuoteCategoryFilter from 'pages/Quotes/components/QuoteCategoryFilter/QuoteCategoryFilter';
import QuoteStatusFilterNew from 'pages/Quotes/components/QuoteStatusFilterNew/QuoteStatusFilterNew';
import DisplayGridFilter from 'pages/Quotes/components/DisplayGridFilter/DisplayGridFilter';
import { VisibilityConditional } from 'components/VisibilityConditional';
import RadioButtons from 'pages/Quotes/components/RadioButtons';
import { Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import { Button } from 'components/Button';
import Text from 'components/Text';
//interfaces
import { HeaderGridProps } from './interface';
//styles
import { SearchInput, ContainerSearch, SearchButton, ColumnVerticalLine, CustomIcon, FiltersContainer, RadioButtonsContainer, SearchContainer, SearchIconWrapper, Divider } from './styles';
import '../../components/QuoteStatusFilter/style.scss';
//assets
import IndicatorFilterIcon from "img/icon-reset-filter.svg";
import SearchIcon from "img/search-icon.svg";

const HeaderGrid: React.FC<HeaderGridProps> = (props) => {
  const {
    filterText,
    getPreOrder,
    statusViveo,
    orderStatus,
    resetFilters,
    setFilterText,
    statusBionexo,
    quoteCategory,
    origin,
    selectedRadio,
    setCurrentPage,
    setStatusViveo,
    setOrderStatus,
    getBionexoQuote,
    setQuoteCategory,
    setOrigin,
    setSelectedRadio,
    setStatusBionexo,
    orderRadioSelected,
    dashboardQuoteFilter,
    setOrderRadioSelected,
    resetCardSelection,
    setNoRefresh,
    selectedGridOption,
    setSelectedGridOption,
    resetButtonDisabled
  } = props;
const [length, setLength] = useState<number>(0);

  const allQuotesDashboard = JSON.parse(process.env.REACT_APP_ALL_QUOTES_DASHBOARD!);
  const ruleColorDropdownStatus = statusBionexo.length > 3 || statusViveo.length > 3;
  const categoryDropdownRule = quoteCategory.length > 4;
  const noStatusSelected =
    allQuotesDashboard &&
    (orderRadioSelected
      ? (orderStatus?.length ?? 0) === 0
      : statusBionexo.length + statusViveo.length === 0);

  const dispatch = useDispatch();

  const clickEnterButton = (event: string) => {
    if (event === "Enter") {
      if (noStatusSelected) {
        return;
      }
      const trimmedFilterText = filterText.trim();
      setNoRefresh(true);

      if (trimmedFilterText === "") {
        if (!orderRadioSelected) {
          getBionexoQuote("", statusBionexo, statusViveo, quoteCategory, true, false, origin);
        } else {
          getPreOrder("", orderStatus, quoteCategory, true, selectedGridOption);
        }
      } else {
        if (!orderRadioSelected) {
          getBionexoQuote(
            trimmedFilterText,
            statusBionexo,
            statusViveo,
            quoteCategory,
            true,
            false,
            origin
          );
        } else {
          getPreOrder(
            trimmedFilterText,
            orderStatus,
            quoteCategory,
            true,
            selectedGridOption
          );
        }
      }
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterText(e.target.value);
  };

  const handleShowTipContent = () => {
    if (noStatusSelected) {
      return 'Selecione um ou mais status para habilitar o filtro.';
    }

    if (ruleColorDropdownStatus) {
      return 'É permitido selecionar apenas 3 opções de cada status';
    }

    if (categoryDropdownRule) {
      return 'É permitido selecionar apenas 4 opções de categoria';
    }

    return '';
  };

  const searchButtonOnClick = () => {
    if (noStatusSelected) {
      return;
    }
    if (orderRadioSelected) {
      setNoRefresh(true);
      getPreOrder(filterText, orderStatus, quoteCategory, true, selectedGridOption);

      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: []
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: []
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: quoteCategory
      });
    } else {
      setNoRefresh(true);
      dispatch({
        type: "SET_STATUS_BIONEXO",
        statusBionexo: statusBionexo
      });
      dispatch({
        type: "SET_STATUS_VIVEO",
        statusViveo: statusViveo
      });
      dispatch({
        type: "SET_QUOTE_CATEGORIES",
        quoteCategory: quoteCategory
      });

      getBionexoQuote(filterText, statusBionexo, statusViveo, quoteCategory, true);
    }
  };

  const renderOrderInputText = () => {
    return (
      <Text className="StatusFilterLabel" size={12}>
        Buscar ID, razão social, cód. do cliente
      </Text>
    );
  };

  const renderQuoteInputText = () => {
    return (
      <Text className="StatusFilterLabel" size={12}>
        Buscar ID, razão social, cód. do cliente, descrição do produto
      </Text>
    );
  };

  useEffect(() => {
    if (resetCardSelection !== 0) {
      dispatch(Actions.setSelectedFilterCard(null));
    }
  }, [resetCardSelection, dispatch]);

  useEffect(() => {
    if (!orderRadioSelected && setSelectedGridOption) {
      setSelectedGridOption(0);
    }
  }, [orderRadioSelected, setSelectedGridOption]);  

  return (
    <Row className="w-100 align-center justify-between">
      <ContainerSearch className="w-sm-100 mt-3 mt-sm-1 mb-4 mb-sm-2 w-100">
        <Row className={`${allQuotesDashboard ? '' : 'w-10'} ${orderRadioSelected ? 'order-filters-row' : 'quotes-filters-row'} header-grid-main-row`}>
          <RadioButtonsContainer>
            <RadioButtons
              getPreOrder={getPreOrder}
              selectedRadio={selectedRadio}
              setStatusViveo={setStatusViveo}
              setOrderStatus={setOrderStatus}
              getBionexoQuote={getBionexoQuote}
              setStatusBionexo={setStatusBionexo}
              setSelectedRadio={setSelectedRadio}
              setOrderRadioSelected={setOrderRadioSelected}
            />
          </RadioButtonsContainer>

          <FiltersContainer>
            <Visibility visible={allQuotesDashboard}>
              {orderRadioSelected && !!setSelectedGridOption && (
                <div className="order-filter-display">
                  <DisplayGridFilter
                    selectedGridOption={selectedGridOption ?? 0}
                    setSelectedGridOption={setSelectedGridOption!}
                  />
                </div>
              )}

              <div className={orderRadioSelected ? 'order-filter-category' : ''}>
                <QuoteCategoryFilter
                  selectedQuoteCategory={quoteCategory}
                  dashboardQuoteFilter={dashboardQuoteFilter}
                  setQuoteCategory={setQuoteCategory}
                  setCurrentPage={setCurrentPage}
                  notReloadStatus={true}
                />
              </div>

              <div className={orderRadioSelected ? 'order-filter-status' : ''}>
                <QuoteStatusFilterNew
                  selectedBionexoStatus={statusBionexo}
                  selectedViveoStatus={statusViveo}
                  selectedOrderStatus={orderStatus}
                  orderRadioSelected={orderRadioSelected}
                  dashboardQuoteFilter={dashboardQuoteFilter}
                  setStatusBionexo={setStatusBionexo}
                  setStatusViveo={setStatusViveo}
                  setOrderStatus={setOrderStatus}
                  setCurrentPage={setCurrentPage}
                  notReloadStatus={true}
                />
              </div>
            </Visibility>

            <div className="filter-buttons-container">
              <SearchButton
                id="search-button"
                onClick={() => searchButtonOnClick()}
                disabled={noStatusSelected || ruleColorDropdownStatus || categoryDropdownRule}
              >
                <Text
                  className="font-bold"
                  showTip={noStatusSelected || ruleColorDropdownStatus || categoryDropdownRule}
                  showTipContent={handleShowTipContent()}
                  color="#ffffff"
                >
                  Filtrar
                </Text>
              </SearchButton>

              <Button 
                width={143}
                id="button-reset-filter"
                className="outline bg-primary flex-sm-1 align-center justify-center d-flex reset-button"
                disabled={resetButtonDisabled}
                onClick={() => {
                  if(resetFilters) {
                    resetFilters();
                  }
                }}
              >
                <CustomIcon src={IndicatorFilterIcon} alt="Icon" />
                <Text className="color-primary font-bold">Resetar</Text>
              </Button>
            </div>
          </FiltersContainer>

          <Divider />

          <SearchContainer>
            <VisibilityConditional
              condition={orderRadioSelected}
              firstOption={() => renderOrderInputText()}
              secondOption={() => renderQuoteInputText()}
            />

            <div className="search-input-wrapper">
              <SearchInput
                onKeyPress={(e) => clickEnterButton(e.key)}
                onChange={handleSearchChange}
                value={filterText}
                type="text"
                isOrderView={orderRadioSelected}
                placeholder="Buscar por produto, cód. do cliente, descrição do produto ou ID"
              />
              <SearchIconWrapper>
                <img src={SearchIcon} alt="Search" />
              </SearchIconWrapper>
            </div>
          </SearchContainer>
        </Row>
      </ContainerSearch>
    </Row>
  );
};

export default HeaderGrid;